module.exports = __webpack_public_path__ + "img/map-location-square.080ae4d0.png";